import { Action } from '@ngrx/store';

import { Event } from '../event.model';

export const SET_EVENTS = 'SET_EVENTS';
export const ADD_EVENT = 'ADD_EVENT';
export const UPDATE_EVENT = 'UPDATE_EVENT';
export const DELETE_EVENT = 'DELETE_EVENT';
export const STORE_EVENTS = 'STORE_EVENTS';
export const FETCH_EVENTS = 'FETCH_EVENTS';
// export const STORE_KEY_TABLE = 'STORE_KEY_TABLE';

export class SetEvents implements Action {
  readonly type = SET_EVENTS;

  constructor(public payload: Event[]) {}
}

export class AddEvents implements Action {
  readonly type = ADD_EVENT;

  constructor(public payload: Event) {}
}

export class UpdateEvent implements Action {
  readonly type = UPDATE_EVENT;

  constructor(public payload: {index: number, updatedEvent: Event}) {}
}

export class DeleteEvent implements Action {
  readonly type = DELETE_EVENT;

  constructor(public payload: number) {}
}

export class StoreEvents implements Action {
  readonly type = STORE_EVENTS;
}

/*
export class StoreKeyTable implements Action {
  readonly type = STORE_KEY_TABLE;
}
*/
export class FetchEvents implements Action {
  readonly type = FETCH_EVENTS;
}

export type EventActions = SetEvents |
  AddEvents |
  UpdateEvent |
  DeleteEvent |
  StoreEvents |
  // StoreKeyTable |
  FetchEvents;



// WEBPACK FOOTER //
// ./src/app/events/store/event.actions.ts